module.exports = __webpack_public_path__ + "img/line-icon call line.6ee0359e.svg";